var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProtect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76029 15.9842C7.82288 16.0053 7.8914 16.0053 7.954 15.9842V15.985C8.78629 15.7194 14.7143 13.6138 14.7143 7.40166V1.84318C14.7145 1.77168 14.689 1.70219 14.6419 1.64578C14.5948 1.58938 14.5289 1.54931 14.4546 1.53197L7.94029 0.00955169C7.8857 -0.0031839 7.82859 -0.0031839 7.774 0.00955169L1.25972 1.53197C1.1854 1.54931 1.11945 1.58938 1.07237 1.64578C1.0253 1.70219 0.999822 1.77168 1 1.84318V7.40166C1 13.5522 6.92886 15.7122 7.76029 15.9842ZM8.81641 4.30859V6.58359L11.0938 6.58359V8.18359H8.81641V10.4624H7.21641V8.18359H4.9399L4.9399 6.58359H7.21641V4.30859H8.81641Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtect);
export default __webpack_public_path__ + "static/media/icon-protect.fa101feb53d6278be23dbd7493063cac.svg";
export { ForwardRef as ReactComponent };